import { Plus } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { Button, PermissionGuard } from "@/components";
import { useI18n } from "@/context/i18n";

import { TablesUsers } from "./components/tables-users";
import { TUserTeamFormData } from "./team-form/team-form.schema";
import { useUsers } from "./users.hooks";

export interface ITeamFormProps {
  form: UseFormReturn<TUserTeamFormData>;
}

export function UsersPage() {
  const { t } = useI18n();
  const { users = [], deleteClient } = useUsers();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-full h-full space-y-6 p-4">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col w-full px-2">
          <h1 className="text-3xl font-bold tracking-tight">
            {t("users.title")}
          </h1>
          <p className="text-muted-foreground">{t("users.description")}</p>
        </div>
        <div className="flex justify-end mb-4">
          <PermissionGuard permission="user:create">
            <Button onClick={() => navigate("/team-form")}>
              <Plus className="mr-2 h-4 w-4" />
              {t("generic.new")}
            </Button>
          </PermissionGuard>
        </div>
      </div>
      <TablesUsers users={users} onDelete={(id) => deleteClient(id)} />
    </div>
  );
}
